import(/* webpackMode: "eager" */ "/home/interim/frontend/app/faq/page.tsx");
